/*
 * File: index.tsx
 * Desc: 拖拽监听容器
 * File Created: 2019-12-03 16:52:21
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useRef } from 'react';

interface DragContainerProps {
    children?: React.ReactNode;
}
interface IDrag {
    state?: React.DragEvent<HTMLDivElement>['type'];
}

export const DragContext = React.createContext<{ drag: IDrag; setDrag: Function }>({
    drag: {},
    setDrag: () => {},
});

const DragContainer = (props: DragContainerProps) => {
    const [drag, setDrag] = useState<IDrag>({});
    /** 避免dragLeave在子元素上触发的问题 */
    const enterCounter = useRef<number>(0);

    function setDragState(event: React.DragEvent<HTMLDivElement>) {
        event.stopPropagation();
        event.preventDefault();
        setDrag({ state: event.type });
    }

    function dragEnter(event: React.DragEvent<HTMLDivElement>) {
        enterCounter.current++;
        setDragState(event)
    }

    function dragLeave(event: React.DragEvent<HTMLDivElement>) {
        enterCounter.current--;
        if (enterCounter.current < 1) {
            setDragState(event);
        }
    }

    return (
        <DragContext.Provider value={{ drag, setDrag }}>
            <div
                onDragLeave={dragLeave}
                onDragExit={setDragState}
                onDragEnter={dragEnter}
                onDrop={setDragState}
            >
                {props.children}
            </div>
        </DragContext.Provider>
    );
};

export default DragContainer;
